import { Pipe, PipeTransform } from '@angular/core';
import { GlobalCentreNumerisationDTO } from '../shared/models/iCourrier/centre-numerisation/global-centre-numerisation';
import { BinderClassificationDtoV2, DropdownService, SourceDto } from '../shared/interfaces';
import { UserDto } from '../shared/interfaces/users';

@Pipe({
  name: 'QrCodeExplodeRegexpFull',
})
export class QrCodeExplodeRegexpFull implements PipeTransform {
  transform(
    value: string,
    expressionReguliereFull: RegExp,
    numerisationCenter: GlobalCentreNumerisationDTO[],
    services: DropdownService[],
    sources: SourceDto[],
    destinataires: UserDto[],
    codesClassement: BinderClassificationDtoV2[],
    showAllServices = true
  ): string {
    const results = [];

    // En premier lieu, on va récupérer toutes les valeurs correspondants à la RegExp
    const values = value.match(expressionReguliereFull);

    // Puis, pour chaque occurrence, on va extraire la balise et son contenu
    if (values?.length > 0) {
      values.forEach((item: string) => {
        const arr = item.split(/<([^>]+)>/);
        results.push({ balise: arr[1], contenu: arr[2] });
      });
    }

    return this.setContentDataOfQRCode(results, numerisationCenter, services, sources, destinataires, codesClassement, showAllServices);
  }

  private setContentDataOfQRCode(
    results,
    numerisationCenter: GlobalCentreNumerisationDTO[],
    services: DropdownService[],
    sources: SourceDto[],
    destinataires: UserDto[],
    codesClassement: BinderClassificationDtoV2[],
    showAllServices = true
  ): string {
    // Enfin, pour chaque balise/contenu, on va chercher la valeur correspondante dans la liste envoyée par le projet principal afin d'en afficher le label en tooltip
    if (results && results.length > 0) {
      const centreNumContent = results.find((x) => x.balise === 'CENTERNUM')?.contenu;
      const serviceContent = results.find((x) => x.balise === 'SVCID')?.contenu;
      const SourceContent = results.find((x) => x.balise === 'SRCID')?.contenu;
      const destContent = results.find((x) => x.balise === 'DESTCNTID')?.contenu;
      const codeClassementContent = results.find((x) => x.balise === 'CODECLASSID')?.contenu;

      const centreNumLabel = centreNumContent ? numerisationCenter.find((x) => x.codeQr === centreNumContent)?.description : null;
      let serviceLabel = null;
      if (serviceContent) {
        if (!showAllServices) {
          // ici on ne peut pas voir tous les services. ce qui veut dire qu'on doit récupérer l'information de quel service on a à faire et s'il a un parentId alors on doit récupérer le parent le plus haut
          const serviceFound = services.find((x) => x.value == serviceContent);
          serviceFound ? (serviceLabel = this.recursion(serviceFound, services)) : (serviceLabel = null);
        } else {
          serviceLabel = services.find((x) => x.value == serviceContent)?.label;
        }
      }
      const sourceLabel = SourceContent ? sources.find((x) => x.id == SourceContent)?.description : null;
      const recipient = destContent ? destinataires.find((x) => x.contactForUser.contactId == destContent) : null;
      const recipientLabel = recipient ? recipient.contactForUser.nom + ' ' + recipient.contactForUser.prenom : null;
      const classificationCode = codeClassementContent ? codesClassement.find((x) => x.id == codeClassementContent) : null;
      const classificationCodeLabel = classificationCode ? classificationCode.code + ' ' + classificationCode.description : null;

      return this.setTooltipISCanQRCode(centreNumLabel, serviceLabel, sourceLabel, recipientLabel, classificationCodeLabel, showAllServices);
    } else {
      return '';
    }
  }

  private recursion(serviceFound, servicesList): string {
    if (serviceFound?.parentId) {
      const parent = servicesList.find((x) => x.value == serviceFound.parentId);
      if (parent.parentId) {
        return this.recursion(parent, servicesList);
      } else {
        return parent.label;
      }
    } else {
      return serviceFound.label;
    }
  }

  private setTooltipISCanQRCode(centreNumLabel, serviceLabel, sourceLabel, recipientLabel, classificationCodeLabel, showAllServices): string {
    let finalString = ``;
    if (serviceLabel) {
      finalString += `Service : ${serviceLabel + ' ' + (!showAllServices ? "(D'autres données sont disponibles mais votre accès étant restreint, vous ne pouvez pas les visualiser. Vous pouvez demander la suppression de cette restriction)" : '')}`;
    }
    if (centreNumLabel) {
      finalString += `
      Centre de numérisation : ${centreNumLabel}`;
    }
    if (sourceLabel) {
      finalString += `
      Source : ${sourceLabel}`;
    }
    if (recipientLabel) {
      finalString += `
      Destinataire : ${recipientLabel}`;
    }
    if (classificationCodeLabel) {
      finalString += `
      Code de classement : ${classificationCodeLabel}`;
    }
    return finalString;
  }
}
